<template>
  <div id="app">
    <div class="bg-light">
      <nav class="navbar navb">
        <!-- <div class="d-flex justify-content-center" id="heading-area"> -->
        <div class="container" id="heading-area">
          <div class="you-are">
            <!--<span class="d-none d-md-block">You are:</span>-->
            <h1>Let's get you scanning!</h1>
          </div>
          <a href="https://www.keyzapp.com/login">
            <img class="d-none d-md-block" src="./assets/keyzapp-logo.png" />
          </a>
        </div>
      </nav>
      <div id="body-area" class="container d-flex justify-content-center">
        <div class="d-flex flex-column justify-content-between align-content-center">
          <div
            id="content-area"
            class="d-flex flex-column flex-grow-1 flex-fill justify-content-center align-content-center m-3"
          >
            <div class="flex-fill card-container" :style="this.viewState.cardHeightStyle">
              <Card
                v-for="question in questions"
                :key="question.qName"
                :cardData="question"
                :viewState="viewState"
                @complete="ProcessQuestionResult"
                @GoToPreviousCard="GoToPreviousCard"
                @Reset="ResetModel"
                @cardHeight="UpdateCardHeight"
              />
            </div>
          </div>
          <div id="helpinfo" class="text-center">
            <h3>Stuck?</h3>
            <h4>Call us at any time: +44 (0)3300 88 55 01</h4>
            <p>
              <a :href="emailMessage">Email us for help</a>
            </p>
          </div>
          <div v-if="this.viewState.debug" id="debug-area">
            <p>{{this.modelState}}</p>
            <p>{{this.viewState}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './app.css';
import Card from './components/Card.vue';

import q from './data/questions.kzq.json';

export default {
  name: 'app',
  components: {
    Card,
  },
  data() {
    return {
      modelState: {
        WorkedBefore: null,
        RedLight: null,
        BeepsWhenScanned: null,
        IsPC: null,
        TriedUnPlugSamePort: null,
        TriedUnPlugNewPort: null,
        CompanionRunning: null,
        CompanionRefreshed: null,
        CompanionInstalledAndRunning: null,
        InstallKeyzappCompanion: null,
        NFCIdeasInstalled: null,
        NFCIdeasConfig: null,
        AddNFCIdeasToDock: null,
        Fixed: null,
      },
      viewState: {
        debug: false,
        currentQuestion: 'WorkedBefore',
        currentCardHeight: 0,
        cardHeightStyle: '',
        showAll: false,
        navigateForward: true,
        previousQuestions: [],
      },
      questions: q.questions,
    };
  },
  methods: {
    ProcessQuestionResult(result) {
      console.log('ProcessQuestionCalled');
      switch (result.name) {
        case 'BeepsWhenScanned':
          this.modelState.BeepsWhenScanned = result.value;
          if (this.modelState.BeepsWhenScanned) {
            this.modelState.RedLight = true;
          }
          break;

        default:
          this.modelState[result.name] = result.value;
      }
      this.viewState.navigateForward = true;
      this.getNextCard();
    },
    getNextCard() {
      this.viewState.previousQuestions.unshift(this.viewState.currentQuestion);
      switch (this.viewState.currentQuestion) {
        case 'WorkedBefore':
          this.viewState.currentQuestion = this.modelState.WorkedBefore
            ? 'BeepsWhenScanned'
            : 'IsPC';
          break;
        case 'BeepsWhenScanned':
          {
            let nextCard = '';
            if (
              this.modelState.BeepsWhenScanned
              && this.modelState.CompanionRunning
            ) {
              nextCard = 'Fixed';
            } else if (
              this.modelState.BeepsWhenScanned
              && (this.modelState.TriedUnPlugSamePort
                || this.modelState.TriedUnPlugNewPort)
            ) {
              nextCard = 'Fixed';
            } else if (
              this.modelState.BeepsWhenScanned
              && this.modelState.IsPC == null
            ) {
              nextCard = 'IsPC';
            } else if (
              this.modelState.BeepsWhenScanned
              && this.modelState.IsPC != null
            ) {
              nextCard = 'GetHelp';
            } else if (!this.modelState.TriedUnPlugSamePort) {
              nextCard = 'TryUnPlugSamePort';
            } else if (!this.modelState.TriedUnPlugNewPort) {
              nextCard = 'TryUnPlugNewPort';
            } else {
              nextCard = 'GetHelp';
            }
            this.viewState.currentQuestion = nextCard;
          }
          break;

        case 'TryUnPlugSamePort':
          this.modelState.TriedUnPlugSamePort = true;
          this.viewState.currentQuestion = this.modelState.BeepsWhenScanned
            ? 'RedLight'
            : 'BeepsWhenScanned';
          break;

        case 'TryUnPlugNewPort':
          this.modelState.TriedUnPlugNewPort = true;
          this.viewState.currentQuestion = this.modelState.BeepsWhenScanned
            ? 'RedLight'
            : 'BeepsWhenScanned';
          break;

        case 'RedLight':
          this.viewState.currentQuestion = this.modelState.RedLight
            ? 'IsPC'
            : 'BeepsWhenScanned';
          break;
        case 'IsPC':
          this.viewState.currentQuestion = this.modelState.IsPC
            ? 'CompanionRunning'
            : 'NFCIdeasInstalled';
          break;
        case 'CompanionRunning':
          this.viewState.currentQuestion = this.modelState.CompanionRunning
            ? 'CompanionRefreshed'
            : 'CompanionInstalledAndRunning';
          break;
        case 'CompanionRefreshed':
          this.viewState.currentQuestion = 'Fixed';
          break;
        case 'CompanionInstalledAndRunning':
          this.viewState.currentQuestion = this.modelState
            .CompanionInstalledAndRunning
            ? 'Fixed'
            : 'InstallKeyzappCompanion';
          break;
        case 'InstallKeyzappCompanion':
          this.viewState.currentQuestion = this.modelState
            .InstallKeyzappCompanion
            ? 'Fixed'
            : 'GetHelp';
          break;
        case 'NFCIdeasInstalled':
          this.viewState.currentQuestion = this.modelState.NFCIdeasInstalled
            ? 'NFCIdeasConfig'
            : 'GetHelp';
          break;
        case 'NFCIdeasConfig':
          this.viewState.currentQuestion = this.modelState.NFCIdeasInstalled
            ? 'AddNFCIdeasToDock'
            : 'GetHelp';
          break;
        case 'AddNFCIdeasToDock':
          this.viewState.currentQuestion = this.modelState.AddNFCIdeasToDock
            ? 'Fixed'
            : 'GetHelp';
          break;
        case 'Fixed':
          {
            let nextCard = '';
            if (this.modelState.Fixed) {
              nextCard = 'IssueResolved';
            } else if (!this.modelState.BeepsWhenScanned) {
              nextCard = 'BeepsWhenScanned';
            } else if (this.modelState.IsPC == null) {
              nextCard = 'IsPC';
            } else if (
              this.modelState.IsPC
              && !this.modelState.CompanionRunning
            ) {
              nextCard = 'CompanionRunning';
            } else {
              nextCard = 'GetHelp';
            }
            this.viewState.currentQuestion = nextCard;
          }
          break;
        case 'FixedMac':
          this.viewState.currentQuestion = this.modelState.FixedMac
            ? 'IssueResolved'
            : 'GetHelp';
          break;
        default:
          this.viewState.currentQuestion = 'RedLight';
      }
    },
    GoToPreviousCard() {
      this.viewState.navigateForward = false;
      // eslint-disable-next-line prefer-destructuring
      this.viewState.currentQuestion = this.viewState.previousQuestions[0];
      this.viewState.previousQuestions.shift();
    },
    ResetModel() {
      this.viewState.navigateForward = false;
      // eslint-disable-next-line no-return-assign
      Object.keys(this.modelState).forEach(v => (this.modelState[v] = null));
      this.viewState.previousQuestions = [];
      this.viewState.currentQuestion = 'WorkedBefore';
    },
    UpdateCardHeight(height) {
      this.viewState.currentCardHeight = height;
      this.viewState.cardHeightStyle = `min-height:${height}px;`;
    },
  },
  computed: {
    emailMessage() {
      const result = `mailto:support@keyzapp.com
      ?subject=Reader Not Working
      &body=Your Phone Number so we can call you back:%0D%0DPlease Leave a message here:%0D%0D
      This is info for us so we can help you more quickly:%0D'
      ${JSON.stringify(this.modelState)}`;
      return result;
    },
  },
  watch: {
    viewState: {
      deep: true,
      handler(newState) {
        console.log(`Question Changed to: ${newState.currentQuestion}`);
        this.$ga.page(this.viewState.currentQuestion);
      },
      // console.log(newState.currentQuestion);
    },
  },
};
</script>

<style>
#app {
  font-family: "Open Sans" sans-serif;
  /*
  text-align: center;
  color: #2c3e50;
  */
}
#body-area {
  min-height: calc(100vh - 93px);
}

h1 {
  font-family: "Arial";
}

button {
  border-radius: 5px;
}

ol,
ul {
  margin: 10px;
}

li {
  text-align: left;
}

.card-container {
  width: 650px;
}
.you-are {
  font-size: 14px;
}
@media screen and (max-width: 768px) {
  .card-container {
    width: 95vw;
    height: auto;
  }
}
</style>
